export const TITLE = {
  en: 'Broker verification',
  th: 'ยืนยันตัวตนสำหรับนายหน้า',
}

export const DESCRIPTION = {
  en: 'Please upload a signed copy of your identification card for identity verification.',
  th: 'กรุณาอัพโหลดสำเนาบัตรประชาชนพร้อมเซ็นรับรองสำเนาถูกต้องเพื่อยืนยันตัวตน',
}

export const SUBMIT = { en: 'Submit', th: 'ส่งเอกสาร' }
